import SidebarContentBonus from './sidebar_content_bonus.png';
import SidebarContentGameRules from './sidebar_content_game_rules.png';
import SidebarContentHelp from './sidebar_content_help.png';
import SidebarContentInvites from './sidebar_content_invites.png';
import SidebarContentLogin from './sidebar_content_login.png';
import SidebarContentLogout from './sidebar_content_logout.png';
import SidebarContentPersonalData from './sidebar_content_personal_data.png';
import SidebarContentRankings from './sidebar_content_rankings.png';
import SidebarContentSettings from './sidebar_content_settings.png';
import SidebarContentShop from './sidebar_content_shop.png';
import SidebarContentTutorial from './sidebar_content_tutorial.png';

export {
	SidebarContentBonus,
	SidebarContentGameRules,
	SidebarContentHelp,
	SidebarContentInvites,
	SidebarContentLogin,
	SidebarContentLogout,
	SidebarContentPersonalData,
	SidebarContentRankings,
	SidebarContentSettings,
	SidebarContentShop,
	SidebarContentTutorial,
};
